import { render, staticRenderFns } from "./testing.vue?vue&type=template&id=481522dc&scoped=true&"
import script from "./testing.vue?vue&type=script&lang=js&"
export * from "./testing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481522dc",
  null
  
)

component.options.__file = "testing.vue"
export default component.exports